import React, { createContext, useContext, useState, useEffect } from "react";

const FilterContext = createContext();

export const useFilterContext = () => {
  return useContext(FilterContext);
};

export const FilterProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [salesperson, setSalesperson] = useState(null);
  const [party, setParty] = useState(null);
  const [supplier, setSupplier] = useState(null);
  return (
    <FilterContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedFilter,
        setSelectedFilter,
        salesperson,
        setSalesperson,
        party,
        setParty,
        supplier,
        setSupplier,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
